import { ErrorMessage, Heading, Layout, RadioButton } from "@vwfs-bronson/bronson-react";
import { useTranslation } from "react-i18next";
import { ContactOptionEnum, IPersonalData } from "../../interfaces";
import { useFormikContext } from "formik";

export const ComunicationType = () => {
    const { t } = useTranslation(["personalinformation"]);
    const { values, errors, setFieldValue, touched } = useFormikContext<IPersonalData>();
    return (
        <Layout className="u-mt">
            <Layout.Item>
                <Heading className="u-mb-none u-font-size-fs2" level={2}>
                    {t("personalinformation:comunication-section.title")}
                </Heading>
            </Layout.Item>
            <Layout.Item default="1/3">
                <RadioButton
                    name="contactPreference"
                    id={`contactPreference_${ContactOptionEnum.Phone}`}
                    onChange={() => setFieldValue("contactPreference", ContactOptionEnum.Phone)}
                    checked={values.contactPreference === ContactOptionEnum.Phone}
                >
                    {t("personalinformation:comunication-section.radio-phone-number")}
                </RadioButton>
            </Layout.Item>
            <Layout.Item default="1/3">
                <RadioButton
                    name="contactPreference"
                    id={`contactPreference_${ContactOptionEnum.Email}`}
                    onChange={() => setFieldValue("contactPreference", ContactOptionEnum.Email)}
                    checked={values.contactPreference === ContactOptionEnum.Email}
                >
                    {t("personalinformation:comunication-section.radio-email")}
                </RadioButton>
            </Layout.Item>

            {touched["contactPreference"] && errors["contactPreference"] && (
                <Layout.Item>
                    <ErrorMessage id={`${"contactPreference"}`}>{errors["contactPreference"] as string}</ErrorMessage>
                </Layout.Item>
            )}
        </Layout>
    );
};
